// Arabische teksten van aanmelden en abonnement (zie billingApp.nl.ts).
export const appBillingAr = {
    signup: {
        steps: ['مرحبًا', 'الحساب', 'التأكيد', 'الأسرة', 'الأفراد', 'الوحدات', 'اللوحة', 'تم'],
        stepOf: 'الخطوة {n} من {total}: {name}',
        welcomeTitle: 'مرحبًا بك في AMUMIN Family Board',
        welcomeBody: 'لوحة هادئة لأسرتكم: التقويم والمهام وغير ذلك، على جهاز لوحي على الحائط وفي هذا التطبيق.',
        trialLine: 'الشهر الأول مجاني. لا تحتاج الآن إلى إدخال بيانات الدفع.',
        languageLabel: 'بأي لغة تريد المتابعة؟',
        start: 'ابدأ',
        closedTitle: 'التسجيل لم يُفتح بعد',
        closedBody: 'سنفتح قريبًا. سجّل في قائمة الانتظار وسنرسل إليك دعوة.',
        closedLink: 'إلى قائمة الانتظار',
        haveAccount: 'هل لديك حساب بالفعل؟',
        login: 'تسجيل الدخول',
        accountTitle: 'حسابك',
        accountBody: 'تستخدمه لتسجيل الدخول. نستخدم بريدك الإلكتروني لحسابك فقط، ولا نستخدمه للإعلانات أبدًا.',
        name: 'اسمك الأول',
        nameHint: 'هكذا تناديك اللوحة. يمكن تغييره لاحقًا.',
        nameRequired: 'أدخل اسمك الأول.',
        email: 'البريد الإلكتروني',
        method: 'كيف تريد تسجيل الدخول؟',
        methodPassword: 'بكلمة مرور',
        methodLink: 'أرسل لي رابطًا',
        methodLinkHint: 'ستصلك رسالة فيها رمز وزر. ويمكنك دائمًا اختيار كلمة مرور لاحقًا.',
        priceLine: 'شهر واحد مجانًا، ثم {price} شهريًا. يمكنك الإلغاء في أي وقت.',
        priceLinePlaceholder: 'شهر واحد مجانًا، ثم تدفع شهريًا. ستعرف السعر قبل نهاية الشهر بوقت كافٍ. يمكنك الإلغاء في أي وقت.',
        termsBefore: 'أوافق على',
        termsLink: 'الشروط',
        termsAnd: 'وعلى',
        privacyLink: 'بيان الخصوصية',
        termsRequired: 'ضع علامة هنا للمتابعة.',
        createAccount: 'إنشاء الحساب',
        verifyTitle: 'أكّد بريدك الإلكتروني',
        verifyIntro: 'أرسلنا رمزًا إلى {email}. اكتبه أدناه، أو اضغط على الزر في الرسالة.',
        verifyHint: 'لم تصلك رسالة؟ تحقق أيضًا من البريد غير المرغوب فيه، أو اطلب رمزًا جديدًا أدناه.',
        otherEmail: 'بريد إلكتروني آخر',
        linkBusy: 'جارٍ تأكيد بريدك الإلكتروني…',
        linkVerifiedTitle: 'تم تأكيد بريدك الإلكتروني',
        linkVerifiedBody: 'بدأ شهرك التجريبي. تابع في المتصفح الذي بدأت فيه، أو سجّل الدخول هنا.',
        linkInvalid: 'انتهت صلاحية هذا الرابط أو استُخدم من قبل. سجّل الدخول، أو سجّل من جديد.',
        modulesTitle: 'ماذا تريد أن تستخدم؟',
        modulesBody: 'كل شيء اختياري. لنوع أسرتكم، هذه مفعّلة مسبقًا؛ فعّل أو أوقف ما تريد. يمكنك دائمًا تغيير ذلك لاحقًا في الإعدادات › الوحدات.',
        profileTitle: 'الدين والطعام والأيام الخاصة',
        profileBody: 'فقط إذا أردت. أنت من يختار، وتعطي موافقة منفصلة لذلك.',
        profileButton: 'اختيار',
        boardTitle: 'جهاز لوحي كلوحة',
        boardBody: 'ضع جهازًا لوحيًا على الحائط واربطه برمز QR. لا يوجد جهاز لوحي في متناولك؟ يمكنك فعل ذلك لاحقًا أيضًا، في الإعدادات › الأجهزة اللوحية.',
        boardQr: 'الربط برمز QR',
        boardCode: 'الربط برمز',
        doneTitle: 'مرحبًا بك، كل شيء جاهز',
        doneTrial: 'يستمر شهرك التجريبي حتى {date} ضمنًا.',
        doneNext: [
            'قبل النهاية بأسبوع نرسل إليك تذكيرًا.',
            'هل تريد المتابعة بعد ذلك؟ أضف بيانات الدفع في الإعدادات › الاشتراك. إذا لم تفعل شيئًا، يمكنك الاطلاع على كل شيء، لكن لا يمكنك التغيير بعد ذلك.',
            'يمكنك الإلغاء في أي وقت. لا نحذف أي شيء تلقائيًا أبدًا.',
        ],
        toApp: 'إلى التطبيق',
    },
    page: {
        title: 'الاشتراك',
        settingsHint: 'الشهر التجريبي والدفع والفواتير',
        offTitle: 'لا توجد اشتراكات بعد',
        offBody: 'تستخدم AMUMIN Family Board الآن دون اشتراك.',
        noneTitle: 'لا حاجة إلى اشتراك',
        noneBody: 'لوحة الأسرة هذه ليس لها اشتراك.',
        status: {
            trial: 'الشهر التجريبي',
            active: 'نشط',
            past_due: 'فشل الدفع',
            paused: 'متوقف مؤقتًا',
            cancelled: 'ملغى',
            expired: 'للاطلاع فقط',
        },
        trialLeft: 'الأيام المجانية المتبقية: {n}، حتى {date} ضمنًا.',
        trialLastDay: 'اليوم ({date}) هو آخر يوم مجاني لك.',
        activeUntil: 'مدفوع حتى {date}.',
        activeOpen: 'اشتراكك ساري.',
        cancelledUntil: 'تم الإلغاء. كل شيء يعمل حتى {date} ضمنًا.',
        expiredBody: 'انتهى شهرك التجريبي. كل شيء ما زال موجودًا؛ يمكنك التغيير مجددًا بعد الدفع.',
        pastDueBody: 'لم تنجح الدفعة الأخيرة. أضف بيانات الدفع مرة أخرى.',
        pausedBody: 'أوقفت AMUMIN اشتراكك مؤقتًا. كل شيء يعمل كالمعتاد.',
        plan: 'الخطة',
        perMonth: '{price} شهريًا',
        pricePlaceholder: 'السعر لاحقًا',
        payment: 'بيانات الدفع',
        paymentNone: 'لا توجد بيانات دفع بعد.',
        paymentSet: 'الخصم التلقائي جاهز.',
        addPayment: 'إضافة بيانات الدفع',
        soon: 'قريبًا: الدفع عبر iDEAL ثم الخصم التلقائي.',
        checkoutTitle: 'إضافة بيانات الدفع',
        checkoutBody: 'تدفع الشهر الأول عبر iDEAL. بعد ذلك نخصم المبلغ تلقائيًا كل شهر. يمكنك الإلغاء في أي وقت.',
        startNow: 'أريد أن تستمر الخدمة فورًا. إذا انسحبت خلال 14 يومًا، فلن أدفع إلا عن الأيام التي استخدمتها بالفعل.',
        startNowRequired: 'ضع علامة هنا للمتابعة.',
        toPayment: 'إلى الدفع',
        checkoutOpen: 'هناك دفعة قيد التنفيذ بالفعل. أكملها أولًا، أو حاول مرة أخرى بعد ساعة.',
        paidReturn: 'شكرًا. ستراه هنا بمجرد وصول الدفعة.',
        invoices: 'الفواتير',
        invoicesNone: 'لا توجد فواتير بعد.',
        invoiceStatus: {
            open: 'مفتوحة',
            paid: 'مدفوعة',
            failed: 'لم تنجح',
            refunded: 'مستردة',
            void: 'ملغاة',
        },
        invoiceLine: '{number} · {period} · {amount}',
        cancel: 'إلغاء الاشتراك',
        cancelTitle: 'إلغاء الاشتراك؟',
        cancelBody: 'كل شيء يعمل حتى {date} ضمنًا. بعد ذلك يمكنك الاطلاع على كل شيء، لكن لا يمكنك التغيير. لا نحذف شيئًا.',
        cancelConfirm: 'نعم، ألغِ',
        keep: 'تراجع',
        cancelDone: 'تم إلغاء اشتراكك.',
        resume: 'المتابعة رغم ذلك',
        resumeDone: 'جميل، اشتراكك مستمر.',
        onlyOwner: 'المالك وحده يمكنه الدفع أو الإلغاء.',
        deleteHint: 'هل تريد حذف كل شيء؟ يمكنك ذلك في الإعدادات › بياناتك.',
    },
    banner: {
        expiredTitle: 'انتهى شهرك التجريبي',
        expiredBody: 'ما زال بإمكانك الاطلاع على كل شيء. أضف بيانات الدفع لتتمكن من الإضافة والتغيير مجددًا.',
        pay: 'ادفع',
        readOnly: 'انتهى شهرك التجريبي: يمكنك التغيير مجددًا بعد الدفع.',
    },
    terms: {
        title: 'الشروط (مسودة)',
        intro: 'هذه مسودة. ستُنشر الشروط العامة النهائية هنا قبل فتح التسجيل.',
        points: [
            'الشهر الأول مجاني. لا تحتاج إلى تقديم بيانات الدفع من أجله.',
            'بعد ذلك تدفع شهريًا أو سنويًا، مقدمًا. يمكنك الإلغاء في أي وقت؛ ويستمر الاشتراك حينها حتى نهاية الفترة المدفوعة.',
            'بعد انتهاء الشهر التجريبي دون دفع، يمكنك الاطلاع على كل شيء، لكن لا يمكنك التغيير بعد ذلك. لا نحذف أي شيء تلقائيًا أبدًا.',
            'بصفتك مستهلكًا، لديك حق الانسحاب لمدة 14 يومًا من لحظة بدء الدفع.',
            'كيفية تعاملنا مع بياناتك موضحة في بيان الخصوصية.',
        ],
    },
};
//# sourceMappingURL=billingApp.ar.js.map